export const APP_SHOW_ICONS_HEADER = "APP_SHOW_ICONS_HEADER";
export const APP_SHOW_WINDOW_SIZE = "APP_SHOW_WINDOW_SIZE";
export const SURVEY_FLOW_LOG = "SURVEY_FLOW_LOG";
export const SURVEY_FLOW_IN_ARRAY = "SURVEY_FLOW_IN_ARRAY";
export const STACK_ACTION_LOG = "STACK_ACTION_LOG";
export const SET_API_URL = "SET_API_URL";
export const ANSWER_NOT_SAVE = "ANSWER_NOT_SAVE";
export const APP_SET_PROGRESS = "APP_SET_PROGRESS";
